"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarChartFactory = exports.Category = void 0;
var charts_1 = require("@amcharts/amcharts4/charts");
var core_1 = require("@amcharts/amcharts4/core");
var abstractXYChartFactory_1 = require("./abstractXYChartFactory");
var chartTheme_1 = require("../chartTheme");
var underscore_1 = __importDefault(require("underscore"));
exports.Category = 'category';
var BarChartFactory = /** @class */ (function (_super) {
    __extends(BarChartFactory, _super);
    function BarChartFactory(props) {
        return _super.call(this, props) || this;
    }
    BarChartFactory.prototype.defaultChartType = function () { return charts_1.ColumnSeries; };
    BarChartFactory.prototype.reverseXY = function () { return true; };
    BarChartFactory.prototype.setChartProps = function (chart) {
        _super.prototype.setChartProps.call(this, chart);
        if (this.props.truncate) {
            // Use a couple of more pixels to the left
            chart.leftAxesContainer.paddingLeft = -10;
        }
    };
    /* Always include zero in order to preserve differences, unless there's a negative value in which case the minimum
    * value is used instead. */
    BarChartFactory.prototype.setMinBasedOnData = function (valueAxis) {
        valueAxis.chart.events.on("ready", function () {
            var minPerCategory = valueAxis.chart.data.map(function (v) { return underscore_1.default.min(underscore_1.default.values(v).filter(underscore_1.default.isNumber)); });
            var minOverall = underscore_1.default.min(minPerCategory);
            valueAxis.min = Math.min(0, minOverall);
        });
    };
    BarChartFactory.prototype.configAxes = function (categoryAxis, valueAxis) {
        var _a, _b, _c, _d;
        _super.prototype.configAxes.call(this, categoryAxis, valueAxis);
        categoryAxis.renderer.maxWidth = 130 + ((_a = this.props.extraLabelWidth) !== null && _a !== void 0 ? _a : 0);
        categoryAxis.renderer.labels.template.maxWidth = 130 + ((_b = this.props.extraLabelWidth) !== null && _b !== void 0 ? _b : 0);
        categoryAxis.renderer.labels.template.truncate = (_c = this.props.truncate) !== null && _c !== void 0 ? _c : false;
        categoryAxis.renderer.labels.template.wrap = (_d = (!this.props.truncate)) !== null && _d !== void 0 ? _d : true;
        categoryAxis.renderer.labels.template.contentAlign = 'right';
        // cell padding - grouping of bars
        categoryAxis.renderer.cellStartLocation = 0.1;
        categoryAxis.renderer.cellEndLocation = 0.9;
        if (this.props.truncate) {
            // When truncating labels there is lot's of vertical room for more labels.
            categoryAxis.renderer.minGridDistance = 10;
            // Add tool tip for labels when truncating.
            categoryAxis.renderer.labels.template.tooltipText = "{" + exports.Category + "}";
            categoryAxis.renderer.labels.template.tooltipX = core_1.percent(100);
        }
        valueAxis.renderer.minGridDistance = 50;
        this.setMinBasedOnData(valueAxis);
    };
    /*
    * Need to have different rounded-corner-logic depending on whether the value is positive or negative. Otherwise we
    * could've just set it with: series.columns.template.column.cornerRadius(0, 3, 0, 3);
    * https://stackoverflow.com/questions/56555893/how-to-add-rounded-corners-for-amcharts
    * */
    BarChartFactory.prototype.addCornerRadius = function (series, radius) {
        var radiusFn = function (roundedIfPositive) {
            return function (_radius, target) {
                var _a, _b;
                if (target.dataItem instanceof charts_1.ColumnSeriesDataItem) {
                    return (((_a = target === null || target === void 0 ? void 0 : target.dataItem) === null || _a === void 0 ? void 0 : _a.valueX) >= 0 && roundedIfPositive) ||
                        (((_b = target === null || target === void 0 ? void 0 : target.dataItem) === null || _b === void 0 ? void 0 : _b.valueX) < 0 && !roundedIfPositive)
                        ? radius
                        : 0;
                }
                return 0;
            };
        };
        series.columns.template.column.adapter.add("cornerRadiusTopLeft", radiusFn(false));
        series.columns.template.column.adapter.add("cornerRadiusTopRight", radiusFn(true));
        series.columns.template.column.adapter.add("cornerRadiusBottomLeft", radiusFn(false));
        series.columns.template.column.adapter.add("cornerRadiusBottomRight", radiusFn(true));
    };
    BarChartFactory.prototype.setMinValueZero = function (chart) {
        this.getValueAxis(chart).each(function (valueAxis) {
            if (valueAxis instanceof charts_1.ValueAxis) {
                valueAxis.min = 0;
            }
        });
    };
    BarChartFactory.prototype.addSeriesBullets = function (series) {
        if (series instanceof charts_1.ColumnSeries) {
            this.addCornerRadius(series, 3);
            var valueLabel = BarChartFactory.addColumnSeriesLabelBullets(series, this.getSeriesValueXYName(), this.props.seriesIsIntegerData ? chartTheme_1.numberFormatter0Decimals : chartTheme_1.numberFormatter1Decimals);
            // which point of the label container should be used for anchoring it to the bar ("right" makes it appear inside
            // the bar itself
            valueLabel.label.horizontalCenter = "right";
            var itemWidthThreshold_1 = 30;
            valueLabel.events.on("ready", function (e) {
                if (e.target.dataItem instanceof charts_1.ColumnSeriesDataItem) {
                    var csDataItem = e.target.dataItem;
                    if (csDataItem.valueX < 0) {
                        // we use the left side of the label as center when the value is negative so that it's inside the bar
                        e.target.label.horizontalCenter = "left";
                        e.target.label.fill = chartTheme_1.WhiteColor;
                        // prevent labels from disappearing if value is too small
                        if (csDataItem.itemWidth < itemWidthThreshold_1) {
                            // when the bar is very short and the item is negative, we show it 3 px to the right of the 0 line (y-axis)
                            e.target.label.fill = chartTheme_1.PrimaryTextColor;
                            e.target.label.dx = csDataItem.itemWidth + 3;
                        }
                    }
                    else {
                        // prevent labels from disappearing if value is too small
                        if (csDataItem.itemWidth < itemWidthThreshold_1) {
                            e.target.label.fill = chartTheme_1.PrimaryTextColor;
                            e.target.label.horizontalCenter = "left";
                            e.target.label.dx = 5;
                        }
                    }
                }
            });
        }
    };
    BarChartFactory.addColumnSeriesLabelBullets = function (series, valueXYName, formatter) {
        var valueLabel = series.bullets.push(new charts_1.LabelBullet());
        valueLabel.label.text = "{" + valueXYName + ".formatNumber(\"" + formatter.numberFormat + "\")}";
        valueLabel.label.fill = chartTheme_1.WhiteColor;
        valueLabel.label.fontSize = 11;
        valueLabel.label.fontWeight = "bold";
        valueLabel.label.truncate = false;
        valueLabel.label.hideOversized = false;
        return valueLabel;
    };
    BarChartFactory.prototype.addLegend = function (chart) {
        _super.prototype.addLegend.call(this, chart);
        // make legend markers smaller than default
        chart.legend.markers.template.width = 12;
        chart.legend.markers.template.height = 12;
    };
    return BarChartFactory;
}(abstractXYChartFactory_1.AbstractXYChartFactory));
exports.BarChartFactory = BarChartFactory;
